module.exports = __webpack_public_path__ + "cbca709c177d2911e291d1bbcd62075c.png";